import { DownloadSimpleIcon } from "@phosphor-icons/react/DownloadSimple";
import ShipmentSection from "@/Shared/Shipment/CustomComponents/ShipmentSection";
import { useState } from "react";
import { ResponseError } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { Banner } from "@freightsimple/ui-core/Display/Banner";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";
import { Button } from "@freightsimple/ui-core/Controls/Button";

interface NextStepsSectionProps {
  onDownload: () => Promise<void>;
}

function ShipmentNextStepsSection(props: NextStepsSectionProps) {
  const { onDownload } = props;
  const [error, setError] = useState<ResponseError | null>();
  const [loading, setLoading] = useState(false);

  async function onDownloadClick() {
    setLoading(() => true);
    setError(() => undefined);
    try {
      await onDownload();
    } catch (e) {
      if (e instanceof ResponseError && e.response.status === 404) {
        setError(() => e);
      }
    }
    setLoading(() => false);
  }

  return (
    <ShipmentSection
      title={
        <div
          className="flex flex-row items-center justify-between"
          style={{ marginTop: "16px" }}
        >
          <div className="flex flex-col items-start">
            <div>Next: Your Pickup Package</div>
          </div>
        </div>
      }
      id="next-steps-section"
    >
      <div className="flex flex-col items-start" style={{ marginTop: "-14px" }}>
        <Banner variant="neutral" title="Important Pickup Requirements">
          Have freight ready during the scheduled pickup window. Missed pickup
          charges may apply if the driver cannot complete the pickup. Shippers
          must use only the FreightSimple Bill of Lading from your Pickup
          Package.
        </Banner>

        <div className="h-[16px]" />
        <div className="flex w-full flex-row items-center justify-between">
          <div className="flex flex-col items-start">
            <Tooltip
              side="right"
              content={
                <div className="p-2 text-sm font-light text-content-muted">
                  Contains: Pickup Instructions, Packaging Labels, Bill of
                  Lading, Customs Documents (if applicable)
                </div>
              }
            >
              <Button
                primary
                size="large"
                icon={DownloadSimpleIcon}
                iconWeight="fill"
                onClick={onDownloadClick}
                loading={loading}
              >
                Download Pickup Package PDF
              </Button>
            </Tooltip>
          </div>
        </div>
        {error && (
          <>
            <div className="h-[16px]" />
            <span style={{ color: "var(--color-red)" }}>
              Download failed. Please try again in a moment.
            </span>
          </>
        )}
      </div>
    </ShipmentSection>
  );
}
export default ShipmentNextStepsSection;
